import { Component, ElementRef, Input, OnChanges, OnInit, Renderer2, forwardRef, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'vb-searchable-ctrl',
  templateUrl: './searchable-ctrl.component.html',
  styleUrls: ['./searchable-ctrl.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchableCtrlComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class SearchableCtrlComponent implements OnInit, OnChanges {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);

  static readonly fullWord = 'yes';
  static readonly notSearchable = 'no';
  @Input() formData: any = null;
  @Input() disableField = false;
  @Input() property: any = null;
  @Input() currentNode: any = null;
  @Input() element: any;
  @Input() config: any;
  @Input() techStackData: any;
  private modelValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  isLoading = false;
  searchValue: any = null;
  disabled = false;
  possibleValues: any = [];
  defaultValue: any = null;

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.modelValue = value;
    this.searchValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.searchValue = value;
    this.onChange(this.modelValue);
  }

  valueChange(event) {
    this.set(this.searchValue);
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    this.disabled = isDisabled;
  }

  setPossibleOptions() {
    if (this.techStackData?.runtime === 'GAE first Generation') {
      this.possibleValues = [
        {
          name: 'Starts With',
          value: 'starts_with'
        },
        {
          name: 'Full Word',
          value: 'full_word'
        },
        {
          name: 'Not Searchable',
          value: 'not_searchable'
        }
      ];
      this.defaultValue = 'full_word';
    } else {
      this.possibleValues = [
        {
          name: 'Yes',
          value: 'yes'
        },
        {
          name: 'No',
          value: 'no'
        }
      ];
      this.defaultValue = 'yes';
    }
  }

  ngOnChanges() {
    this.setPossibleOptions();
  }

  ngOnInit(): void {
    this.setPossibleOptions();
  }
}
